var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        visible: _vm.visible,
        "show-footer": false,
        title: _vm.$t("table.ganttSettings"),
        large: "",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "gantt-settings-modal" },
        [
          _c("a-form", { attrs: { form: _vm.form, layout: "vertical" } }, [
            _c(
              "div",
              { staticClass: "settings-section" },
              [
                _c("h4", [_vm._v(_vm._s(_vm.$t("table.requiredFields")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.taskNameField") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "taskNameField",
                              {
                                initialValue: _vm.widget.settings.taskNameField,
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t(
                                      "table.selectTaskNameField"
                                    ),
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'taskNameField',\n                            {\n                                initialValue: widget.settings.taskNameField,\n                                rules: [{ required: true, message: $t('table.selectTaskNameField') }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("table.selectTaskNameField"),
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                        },
                      },
                      _vm._l(_vm.stringFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.startDateField") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "startDateField",
                              {
                                initialValue:
                                  _vm.widget.settings.startDateField,
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t(
                                      "table.selectStartDateField"
                                    ),
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'startDateField',\n                            {\n                                initialValue: widget.settings.startDateField,\n                                rules: [{ required: true, message: $t('table.selectStartDateField') }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("table.selectStartDateField"),
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                        },
                      },
                      _vm._l(_vm.dateFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.endDateField") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "endDateField",
                              {
                                initialValue: _vm.widget.settings.endDateField,
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t("table.selectEndDateField"),
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'endDateField',\n                            {\n                                initialValue: widget.settings.endDateField,\n                                rules: [{ required: true, message: $t('table.selectEndDateField') }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("table.selectEndDateField"),
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                        },
                      },
                      _vm._l(_vm.dateFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "settings-section" },
              [
                _c("h4", [_vm._v(_vm._s(_vm.$t("table.optionalFields")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.progressField") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "progressField",
                              {
                                initialValue: _vm.widget.settings.progressField,
                              },
                            ],
                            expression:
                              "['progressField', { initialValue: widget.settings.progressField }]",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("table.selectProgressField"),
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.numberFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.statusField") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "statusField",
                              { initialValue: _vm.widget.settings.statusField },
                            ],
                            expression:
                              "['statusField', { initialValue: widget.settings.statusField }]",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("table.selectStatusField"),
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.dropdownFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.assigneeField") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "assigneeField",
                              {
                                initialValue: _vm.widget.settings.assigneeField,
                              },
                            ],
                            expression:
                              "['assigneeField', { initialValue: widget.settings.assigneeField }]",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("table.selectAssigneeField"),
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.userFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.priorityField") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "priorityField",
                              {
                                initialValue: _vm.widget.settings.priorityField,
                              },
                            ],
                            expression:
                              "['priorityField', { initialValue: widget.settings.priorityField }]",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("table.selectPriorityField"),
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.dropdownFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "settings-section" },
              [
                _c("h4", [_vm._v(_vm._s(_vm.$t("table.viewSettings")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("table.viewMode") } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "viewMode",
                              {
                                initialValue:
                                  _vm.widget.settings.viewMode || "month",
                              },
                            ],
                            expression:
                              "['viewMode', { initialValue: widget.settings.viewMode || 'month' }]",
                          },
                        ],
                        attrs: { placeholder: _vm.$t("table.selectViewMode") },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "day" } }, [
                          _vm._v(_vm._s(_vm.$t("table.daily"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "week" } }, [
                          _vm._v(_vm._s(_vm.$t("table.weekly"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "month" } }, [
                          _vm._v(_vm._s(_vm.$t("table.monthly"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "quarter" } }, [
                          _vm._v(_vm._s(_vm.$t("table.quarterly"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "year" } }, [
                          _vm._v(_vm._s(_vm.$t("table.yearly"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "showProgress",
                              {
                                initialValue: _vm.$_.get(
                                  _vm.widget,
                                  "settings.customization.showProgress",
                                  true
                                ),
                                valuePropName: "checked",
                              },
                            ],
                            expression:
                              "[\n                            'showProgress',\n                            {\n                                initialValue: $_.get(widget, 'settings.customization.showProgress', true),\n                                valuePropName: 'checked',\n                            },\n                        ]",
                          },
                        ],
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("table.showProgress")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "showWeekends",
                              {
                                initialValue: _vm.$_.get(
                                  _vm.widget,
                                  "settings.customization.showWeekends",
                                  true
                                ),
                                valuePropName: "checked",
                              },
                            ],
                            expression:
                              "[\n                            'showWeekends',\n                            {\n                                initialValue: $_.get(widget, 'settings.customization.showWeekends', true),\n                                valuePropName: 'checked',\n                            },\n                        ]",
                          },
                        ],
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("table.showWeekends")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "showToday",
                              {
                                initialValue: _vm.$_.get(
                                  _vm.widget,
                                  "settings.customization.showToday",
                                  true
                                ),
                                valuePropName: "checked",
                              },
                            ],
                            expression:
                              "[\n                            'showToday',\n                            {\n                                initialValue: $_.get(widget, 'settings.customization.showToday', true),\n                                valuePropName: 'checked',\n                            },\n                        ]",
                          },
                        ],
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("table.showTodayLine")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "SupsisButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("table.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                { attrs: { primary: "" }, on: { click: _vm.handleSave } },
                [_vm._v(_vm._s(_vm.$t("table.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }